import { AxArtwork } from "@dynata/axiom3";
import errorImage from "@dynata/axiom3-images/png/general_error.png";

export function FavoriteProjectsError() {
  return (
    <AxArtwork
      title="There was an error loading your favorite projects"
      image={errorImage}
      description="Error details"
    />
  )
}